import { resolveComponent as _resolveComponent, createVNode as _createVNode, vShow as _vShow, withDirectives as _withDirectives, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveDynamicComponent as _resolveDynamicComponent, KeepAlive as _KeepAlive, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  class: "position-relative"
};
const _hoisted_2 = {
  class: "main-content"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_mc_fix_alert_maintenance = _resolveComponent("mc-fix-alert-maintenance");
  const _component_plan_upgrade_banner = _resolveComponent("plan-upgrade-banner");
  const _component_sidebar_item = _resolveComponent("sidebar-item");
  const _component_side_bar = _resolveComponent("side-bar");
  const _component_router_view = _resolveComponent("router-view");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_mc_fix_alert_maintenance), _createElementVNode("div", {
    class: _normalizeClass(["wrapper", {
      'nav-open': $data.showSidebar
    }])
  }, [_withDirectives(_createVNode(_component_plan_upgrade_banner, null, null, 512), [[_vShow, $data.showSidebarPages.includes(_ctx.$route.name)]]), _withDirectives(_createVNode(_component_side_bar, {
    onClick: _cache[12] || (_cache[12] = $event => $options.closeAll())
  }, {
    links: _withCtx(() => [_createVNode(_component_sidebar_item, {
      link: {
        name: 'Dashboard',
        icon: 'dashboard',
        path: '/dashboard'
      },
      onClick: _cache[0] || (_cache[0] = $event => $options.closeAll())
    }), $data.permission < 5 ? (_openBlock(), _createBlock(_component_sidebar_item, {
      key: 0,
      link: {
        name: 'Campaigns',
        icon: 'campaign'
      },
      modelValue: $data.showCreate,
      "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => $data.showCreate = $event),
      onClick: _cache[2] || (_cache[2] = $event => $options.closeAll('showCreate'))
    }, {
      default: _withCtx(() => [_createVNode(_component_sidebar_item, {
        link: {
          name: 'Regular',
          path: '/campaigns'
        }
      }), _createVNode(_component_sidebar_item, {
        link: {
          name: 'Autoresponders',
          path: '/autoresponder'
        }
      })]),
      _: 1
    }, 8, ["modelValue"])) : _createCommentVNode("", true), _createVNode(_component_sidebar_item, {
      link: {
        name: 'Automations',
        icon: 'automation',
        path: '/advanced-automation'
      },
      onClick: _cache[3] || (_cache[3] = $event => $options.closeAll())
    }), $data.permission < 4 ? (_openBlock(), _createBlock(_component_sidebar_item, {
      key: 1,
      link: {
        name: 'Audience',
        icon: 'audience'
      },
      modelValue: $data.showRecipients,
      "onUpdate:modelValue": _cache[4] || (_cache[4] = $event => $data.showRecipients = $event),
      onClick: _cache[5] || (_cache[5] = $event => $options.closeAll('showRecipients'))
    }, {
      default: _withCtx(() => [$data.allowAudience ? (_openBlock(), _createBlock(_component_sidebar_item, {
        key: 0,
        link: {
          name: 'All contacts',
          path: '/audience/list'
        }
      })) : _createCommentVNode("", true), _createVNode(_component_sidebar_item, {
        link: {
          name: 'Lists',
          path: '/recipients'
        }
      }), _createVNode(_component_sidebar_item, {
        link: {
          name: 'Segments',
          path: '/segment' + ($data.allowAudience ? 's' : '')
        }
      }, null, 8, ["link"]), _createVNode(_component_sidebar_item, {
        link: {
          name: 'Webforms',
          path: '/webform'
        }
      }), _createVNode(_component_sidebar_item, {
        link: {
          name: 'Tags',
          path: '/contact-tag'
        }
      }), _createVNode(_component_sidebar_item, {
        link: {
          name: 'Summary',
          path: '/contact-summary'
        }
      })]),
      _: 1
    }, 8, ["modelValue"])) : _createCommentVNode("", true), _createVNode(_component_sidebar_item, {
      link: {
        name: 'Reports',
        icon: 'reports'
      },
      modelValue: $data.showReport,
      "onUpdate:modelValue": _cache[6] || (_cache[6] = $event => $data.showReport = $event),
      onClick: _cache[7] || (_cache[7] = $event => $options.closeAll('showReport'))
    }, {
      default: _withCtx(() => [_createVNode(_component_sidebar_item, {
        link: {
          name: 'Regular campaigns',
          path: '/campaign-report'
        }
      }), _createVNode(_component_sidebar_item, {
        link: {
          name: 'Automations',
          path: $data.showAdvanced ? '/advanced-automation-report' : '/automation-report'
        }
      }, null, 8, ["link"]), _createVNode(_component_sidebar_item, {
        link: {
          name: 'Autoresponders',
          path: '/autoresponder-report'
        }
      })]),
      _: 1
    }, 8, ["modelValue"]), this.user && this.user.mcTemplate && $data.permission < 5 ? (_openBlock(), _createBlock(_component_sidebar_item, {
      key: 2,
      link: {
        name: 'Template gallery',
        icon: 'gallery'
      },
      modelValue: $data.showGallery,
      "onUpdate:modelValue": _cache[8] || (_cache[8] = $event => $data.showGallery = $event),
      onClick: _cache[9] || (_cache[9] = $event => $options.closeAll('showGallery'))
    }, {
      default: _withCtx(() => [_createVNode(_component_sidebar_item, {
        link: {
          name: 'Template',
          path: '/gallery'
        }
      }), _createVNode(_component_sidebar_item, {
        link: {
          name: 'MC template',
          path: '/mailercloud-templates'
        }
      })]),
      _: 1
    }, 8, ["modelValue"])) : (!this.user || !this.user.mcTemplate) && $data.permission < 5 ? (_openBlock(), _createBlock(_component_sidebar_item, {
      key: 3,
      link: {
        name: 'Template gallery',
        icon: 'gallery',
        path: '/gallery'
      },
      modelValue: $data.showGallery,
      "onUpdate:modelValue": _cache[10] || (_cache[10] = $event => $data.showGallery = $event),
      onClick: _cache[11] || (_cache[11] = $event => $options.closeAll())
    }, null, 8, ["modelValue"])) : _createCommentVNode("", true)]),
    _: 1
  }, 512), [[_vShow, $data.showSidebarPages.includes(_ctx.$route.name)]]), _createElementVNode("div", _hoisted_2, [_createVNode(_component_router_view, null, {
    default: _withCtx(({
      Component,
      route
    }) => [(_openBlock(), _createBlock(_KeepAlive, {
      include: $options.keepAliveComponents
    }, [(_openBlock(), _createBlock(_resolveDynamicComponent(Component), {
      key: route.name
    }))], 1032, ["include"]))]),
    _: 1
  })])], 2)]);
}